import {VuexModule, Module, Mutation, Action, getModule} from 'vuex-module-decorators';
import Store from '@/store';
import ITodoCollection, {ITodo} from '@/models/todoCollection';
import {TodoDataServicesCollection} from '@/accessors/TodoDataServicesCollection';

@Module({namespaced: true, name: 'QuizViewModule', dynamic: true, store: Store})
class QuizViewModule extends VuexModule {
    public score: number = 0;
    public clicks: number = 0;

    @Mutation
    public addPoint() {
        this.score = this.score + 1;
    }

    @Mutation
    public resetScore() {
        this.score = 0;
        this.clicks = 0;
    }

    @Mutation
    public click() {
        this.clicks = this.clicks +1;
    }
}

export default getModule(QuizViewModule);
